/**
 * @class
 * Desribe a generic network request 
 * */
export default class NetworkRequestDescriptor {

    /**
     * @constructor
     * @param {string} protocol Protocol network
     * @param {string} method Method request
     * @param {string} url URL request
     * @param {string} path Path request
     * @param {Object} headers Headers
     * @param {string} queryString Query string
     * @param {Object} body Body request
     * @param {function} deserializer Data deserializer
     */
    constructor(
      protocol,
      method, 
      url,
      path,
      headers,
      queryString,
      body,
      deserializer,
      streaming
    ){  
      this.protocol = protocol
      this.method = method
      this.url = url
      this.path = path
      this.headers = headers
      this.queryString = queryString
      this.body = body
      this.deserializer = deserializer
      this.streaming = streaming
    }
  }
